import React, { ReactNode, useContext, useState } from 'react';
import { styled } from '@mui/material';
import { Checkbox, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
import { isEmpty } from 'lodash';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import withTooltip from 'components/WithTooltip';
import { SelectMultipleProps } from './SelectMultiple.props';
import { classes, StyledFormControl } from './SelectMultiple.styles';

const SelectMultiple = ({
  cell,
  options,
  optionsMask,
  disabled = false,
  defaultOption = 'Select an Option',
}: SelectMultipleProps) => {
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);
  const [value, setValue] = useState<number[]>(cell.value as number[]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setValue(event.target.value as number[]);
  };

  const handleClose = () => {
    if (cell.value && cell.value.toString() !== value.toString()) {
      onCellsChanged([{ cell, value }]);
    }
  };

  const renderValue = (selected: unknown): ReactNode => {
    if (isEmpty(selected)) {
      return defaultOption.toUpperCase();
    }

    const optionList = optionsMask ?? options;
    return (selected as number[]).map((selectedItem: number) => optionList[selectedItem]).join(', ');
  };

  return (
    <StyledFormControl className={classes.root}>
      <Select
        multiple
        displayEmpty
        disableUnderline
        value={value}
        onChange={handleChange}
        onClose={handleClose}
        renderValue={renderValue}
        className={classes.select}
        id={`grid-select-${cell.key}`}
        disabled={disabled || cell.readOnly || isEmpty(options)}>
        <MenuItem disabled value="">
          {defaultOption.toUpperCase()}
        </MenuItem>
        {options.map((option, optionIndex) => (
          <MenuItem value={optionIndex} key={option} dense id={`grid-select-${cell.key}-opt-${optionIndex}`}>
            <Checkbox checked={value.includes(optionIndex)} size="small" className={classes.icon} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default withTooltip(SelectMultiple);
